import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-condensed",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tournament_position = _resolveComponent("tournament-position")!
  const _component_match_bracket = _resolveComponent("match-bracket")!
  const _component_player_info = _resolveComponent("player-info")!

  return (_ctx.tournament.positions.length)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[0],
            key: `p0${_ctx.updateScreen}`
          }, null, 8, ["position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[8])
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "2",
            position: _ctx.tournament.positions[8],
            key: `p8${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[12]),
            rowspan: "4"
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "4",
            position: _ctx.tournament.positions[12],
            key: `p12${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[14]),
            rowspan: "8"
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "8",
            position: _ctx.tournament.positions[14],
            key: `p14${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"])),
          _withDirectives(_createVNode(_component_match_bracket, { rowspan: "16" }, null, 512), [
            [_vShow, _ctx.tournamentSize16]
          ]),
          _withDirectives(_createVNode(_component_player_info, { rowspan: "16" }, null, 512), [
            [_vShow, _ctx.tournamentSize16]
          ])
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[1],
            key: `p1${_ctx.updateScreen}`
          }, null, 8, ["position"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[2],
            key: `p2${_ctx.updateScreen}`
          }, null, 8, ["position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[9])
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "2",
            position: _ctx.tournament.positions[9],
            key: `p9${_ctx.updateScreen}`,
            player: _ctx.tournament.positions[9].player
          }, null, 8, ["disable", "position", "player"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[3],
            key: `p3${_ctx.updateScreen}`
          }, null, 8, ["position"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[4],
            key: `p4${_ctx.updateScreen}`
          }, null, 8, ["position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[10])
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "2",
            position: _ctx.tournament.positions[10],
            key: `p10${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[13]),
            rowspan: "4"
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "4",
            position: _ctx.tournament.positions[13],
            key: `p13${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[5],
            key: `p5${_ctx.updateScreen}`
          }, null, 8, ["position"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[6],
            key: `p6${_ctx.updateScreen}`
          }, null, 8, ["position"])),
          _createVNode(_component_match_bracket, {
            bracketwinner: _ctx.bracketWinner(_ctx.tournament.positions[11])
          }, null, 8, ["bracketwinner"]),
          (_openBlock(), _createBlock(_component_tournament_position, {
            disable: _ctx.edit,
            rowspan: "2",
            position: _ctx.tournament.positions[11],
            key: `p11${_ctx.updateScreen}`
          }, null, 8, ["disable", "position"]))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createBlock(_component_tournament_position, {
            position: _ctx.tournament.positions[7],
            key: `p7${_ctx.updateScreen}`
          }, null, 8, ["position"]))
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info),
          _createVNode(_component_match_bracket),
          _createVNode(_component_player_info, { rowspan: "2" }),
          _createVNode(_component_match_bracket, { rowspan: "4" }),
          _createVNode(_component_player_info, { rowspan: "4" }),
          _createVNode(_component_match_bracket, { rowspan: "8" }),
          _createVNode(_component_player_info, { rowspan: "8" })
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info)
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info),
          _createVNode(_component_match_bracket),
          _createVNode(_component_player_info, { rowspan: "2" })
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info)
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info),
          _createVNode(_component_match_bracket),
          _createVNode(_component_player_info, { rowspan: "2" }),
          _createVNode(_component_match_bracket, { rowspan: "4" }),
          _createVNode(_component_player_info, { rowspan: "4" })
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info)
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info),
          _createVNode(_component_match_bracket),
          _createVNode(_component_player_info, { rowspan: "2" })
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ]),
        _withDirectives(_createElementVNode("tr", null, [
          _createVNode(_component_player_info)
        ], 512), [
          [_vShow, _ctx.tournamentSize16]
        ])
      ]))
    : _createCommentVNode("", true)
}